export default [
  { label: 'Factura afecta', value: '33' },
  { label: 'Factura exenta', value: '34' },
];
